"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const basicTypes = require("./BasicTypeValidator");
const complexTypes = require("./ComplexTypeValidator");
const userInfoTypes = require("./UserInfoValidator");
//==========Ideas==========\\
// not keyword in front of be keyword
//==========validation structure==========\\
const validationEndPoint = "";
const validationObj = {
    should: {
        be: {
            // types, patterns
            int: validationEndPoint,
            decimal: validationEndPoint,
            url: validationEndPoint,
            email: validationEndPoint,
            phoneNumber: validationEndPoint,
            // math operations
            min: validationEndPoint,
            max: validationEndPoint,
        },
        have: {
            // length
            minLength: validationEndPoint,
            maxLength: validationEndPoint,
        }
    }
};
//==========Validator class==========\\
/**
 * Throws an array of type "InputValidationError" one for each check that fails.
 */
class Validator {
    constructor(value) {
        this.value = value;
        this.extraParam = [];
        this.checkArr = [];
        this.checkStrings = [];
        this.errorMessages = [];
        this.arrayIndex = 0;
    }
    be() {
        // int, float, url, email, phone number, name
        if (this.checkArr[2] === "int") {
            basicTypes.isInt(this.value, this.errorMessages[this.arrayIndex]);
        }
        else if (this.checkArr[2] === "decimal") {
            basicTypes.isDecimal(this.value, this.errorMessages[this.arrayIndex]);
        }
        else if (this.checkArr[2] === "url") {
            complexTypes.isUrl(this.value, this.errorMessages[this.arrayIndex]);
        }
        else if (this.checkArr[2] === "email") {
            userInfoTypes.isEmail(this.value, this.errorMessages[this.arrayIndex]);
        }
        else if (this.checkArr[2] === "phoneNumber") {
            userInfoTypes.isPhoneNumber(this.value, this.errorMessages[this.arrayIndex]);
        }
        // math operations
        else if (this.checkArr[2] === "min") {
            basicTypes.min(this.value, this.errorMessages[this.arrayIndex], this.extraParam[this.arrayIndex]);
        }
        else if (this.checkArr[2] === "max") {
            basicTypes.max(this.value, this.errorMessages[this.arrayIndex], this.extraParam[this.arrayIndex]);
        }
    }
    have() {
        // max/min length
        if (this.checkArr[2] === "minLength") {
            basicTypes.minLength(this.value, this.errorMessages[this.arrayIndex], this.extraParam[this.arrayIndex]);
        }
        else if (this.checkArr[2] === "maxLength") {
            basicTypes.maxLength(this.value, this.errorMessages[this.arrayIndex], this.extraParam[this.arrayIndex]);
        }
    }
    should() {
        if (this.checkArr[1] === "be") {
            this.be();
        }
        else if (this.checkArr[1] === "have") {
            this.have();
        }
    }
    validate(checkString, errorMessage, extraParam = "") {
        this.checkStrings.push(checkString);
        this.extraParam.push(extraParam);
        this.errorMessages.push(errorMessage);
        return this;
    }
    and(checkString, errorMessage, extraParam = "") {
        this.validate(checkString, errorMessage, extraParam);
        return this;
    }
    check() {
        let hasError = false;
        let errors = new Array(this.checkStrings.length);
        for (let i = 0; i < this.checkStrings.length; i++) {
            this.arrayIndex = i;
            try {
                this.checkArr = this.checkStrings[i].split(".");
                if (this.checkArr[0] === "should") {
                    this.should();
                }
            }
            catch (e) {
                hasError = true;
                if (e instanceof Error) {
                    errors[this.arrayIndex] = e;
                }
            }
        }
        if (hasError) {
            throw errors;
        }
    }
}
exports.default = Validator;
